import { execute, GET, POST, DELETE, PATCH, PUT} from "."

const baseUrl = (route='') => `api/comments${route}`

export const postComment = ({$store, comments}) => execute({method:PUT, route: baseUrl(`/`), $store, data: comments})

export const getComments = ({$store}) => execute({method:GET, route: baseUrl(`/`), $store})
